import React, { PureComponent } from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Icon, IconButton } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import { styles } from './styles';

interface DialogHeaderComponentProps extends WithStyles<typeof styles> {
  backgroundColor?: string;
  color?: string;
  leftIcon?: string;
  onRequestClose?: () => void;
  title: string;
}

class DialogHeaderComponent extends PureComponent<DialogHeaderComponentProps> {
  static defaultProps = {
    backgroundColor: '',
    color: '',
    leftIcon: '',
  };

  renderCloseButton(style: Record<string, unknown>) {
    const { classes, onRequestClose } = this.props;

    if (!onRequestClose) return;

    return (
      <IconButton className={classes.buttonClose} onClick={onRequestClose} style={style}>
        <CloseIcon />
      </IconButton>
    );
  }

  renderLeftIcon(style: Record<string, unknown>) {
    const { classes, leftIcon } = this.props;

    if (!leftIcon && leftIcon === '') return;

    return (
      <Icon className={classes.leftIcon} style={style}>
        {leftIcon}
      </Icon>
    );
  }

  render() {
    const { backgroundColor, classes, color, title } = this.props;
    const containerStyle: Record<string, unknown> = {};
    const titleStyle: Record<string, unknown> = {};

    if (backgroundColor) containerStyle.backgroundColor = backgroundColor;
    if (color) titleStyle.color = color;

    return (
      <div className={classes.wrapper} style={containerStyle}>
        {this.renderLeftIcon(titleStyle)}
        <Typography className={classes.title} style={titleStyle} variant="h6">
          {title}
        </Typography>
        {this.renderCloseButton(titleStyle)}
      </div>
    );
  }
}

export const DialogHeader = withStyles(styles)(DialogHeaderComponent);
